// import { RouteConfig } from "vue-router";

// export const RCandidateServices: RouteConfig = {
//   path: "cases",
//   name: "CandidateServices",
//   component: () =>
//     import(
//       /* webpackChunkName: "candidate-services-portal" */
//       "@/pages/PortalMicroApp/PortalMicroAppHost.vue"
//     ),
//   meta: {
//     title: "Services",
//     icon: "briefcase-outline",
//     newIcon: "file-certificate",
//     portalPath: "/cases",
//     hideToolbar: true,
//     aliasRoutes: ["employer/services"],
//   },
// };
import { RouteConfig } from "vue-router";
import { RCandidateServicesTemplate } from "@/modules/Services/Template/RServicesTemplate";
import { RCandidateServicesBrowse } from "@/modules/Services/Browse/RServisesBrowse";

export const RCandidateServices: RouteConfig = {
  path: "cases",
  component: () =>
    import(
      /* webpackChunkName: "expert-cases" */
      "@/modules/Services/VServices.vue"
    ),
  meta: {
    title: "Services",
    icon: "briefcase-outline",
    newIcon: "file-certificate",
    aliasRoutes: ["employer/services"],
  },
  children: [RCandidateServicesBrowse, RCandidateServicesTemplate],
};
